class ComponentSlider extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      slider: ".slider",
      previous_button: "button:first-of-type",
      next_button: "button:last-of-type"
    });
  }

  connectedCallback() {
    this.observer();
    this.events();
  }

  observer() {
    const observer = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        const width = entry.contentRect.width;

        if (this.slider) {
          this.teardown();
        }

        this.setup(width);
      });
    });

    observer.observe(this);
  }

  setup(width) {
    if (!this.elements.slider) return;

    const elementWidth = this.elements.slider.getBoundingClientRect().width;
    if (elementWidth === 0) {
      requestAnimationFrame(() => this.setup(width));
      return;
    }

    if (width < 767) {
      return;
    }

    const options = {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      groupCells: 2,
      imagesLoaded: true,
      setGallerySize: true,
      
  dragThreshold: width < 1024 ? 10 : 3,
    };

    this.slider = new Flickity(this.elements.slider, options);

    window.addEventListener('load', () => {
      if (this.slider) {
        this.slider.resize();
      }
    });
  }

  teardown() {
    if (this.slider && typeof this.slider.destroy === 'function') {
      this.slider.destroy();
    }
    this.slider = null;
  }

  next() {
    if (this.slider) {
      this.slider.next();
    }
  }

  previous() {
    if (this.slider) {
      this.slider.previous();
    }
  }
}

customElements.define("component-slider", ComponentSlider);
